<template>
  <div class="admin-list-page">
    <!----------------- Main contents Area --------------------->
    <main class="mt-0">
      <div v-if="isLoading" class="saving-indicator">
        <span class="spinner"></span>
        데이타 로딩 중...
      </div>

      <div class="p-1">
        <h2 class="text-center"><u>&nbsp;상 품 예 약 리 스 트&nbsp;</u></h2>
        <!-- ============ 필터 툴바 ============ -->
        <div class="toolbar-card">
          <div class="top-container d-flex align-items-center justify-content-between">
            <div class="flex-item">
              <select class="form-select form-select-sm field-select" aria-label=".form-select-sm" ref="sel_procCode" v-model="resYear" @change="changeResYear()">
                <option value="2026">2026년 이후</option>
                <option value="2025">2025년 이후</option>
                <option value="2024">2024년 까지</option>
              </select>
            </div>

            <div class="flex-item">
              <button type="button" class="btn btn-del" :disabled="checkedList.length === 0" @click="deleteChecked">
                <i class="bi bi-trash"></i> 선택삭제 ({{ checkedList.length }})
              </button>
            </div>

            <div class="flex-item">
              <select class="form-select form-select-sm field-select" aria-label=".form-select-sm" ref="sel_procCode" v-model="rProcCode" @change="changeProcCode()">
                <option :value="noVal" disabled>진행상태선택</option>
                <option value="A">전체보기</option>
                <option value="NC">신규</option>            
                <option :value="rProcCode.procCode" :key=i v-for="(rProcCode,i) in rProc">{{rProcCode.procName}}</option>
                <option value="FP">전액결제</option>
                <option value="PP">부분결제</option>
                <option value="RF">환불</option>
                <option value="MEM">멤버십</option>
              </select>
            </div>

            <div class="flex-item toggle-item">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" role="switch" id="cancelReservationCheckbox" v-model="noDispCxl" @change="cxlNoDisplay(noDispCxl)">
                <label class="form-check-label" for="cancelReservationCheckbox">취소예약&nbsp;非표시</label>
              </div>
            </div>

            <div class="flex-item search-item">
              <div class="search-box">
                <i class="bi bi-search search-icon"></i>
                <input v-model="dataInput" @input="submitAutoComplete" type="text" class="form-control form-control-sm search-input" placeholder="신청자 또는 상담번호" />
              </div>
              <div class="autocomplete disabled">
                <div class="ac-item" :key="i" v-for="(res,i) in result" @click="searchData(res)">{{ res }}</div>
              </div>
            </div>
          </div>

          <div class="count-bar">
            총 <b>{{ totalCount }}</b>건 조회됨
          </div>
        </div>

        <!-- ============ 재무 요약바 ============ -->
        <div style="font-weight: 600; padding-left: 8px;">
          <span>📈 총액요약 (확정기준)</span>
        </div>
        <div class="summary-bar">
          <div class="summary-stat stat-revenue">
            <div class="stat-label">총매출액</div>
            <div class="stat-value">{{ getCurrencyFormat(summaryTotals.totalRevenue) }} 원</div>
          </div>
          <div class="summary-stat stat-paid">
            <div class="stat-label">실제결제총액</div>
            <div class="stat-value">{{ getCurrencyFormat(summaryTotals.totalPaid) }} 원</div>
          </div>
          <div class="summary-stat stat-coupon">
            <div class="stat-label">쿠폰사용액</div>
            <div class="stat-value">{{ getCurrencyFormat(summaryTotals.totalCoupon) }} 원</div>
          </div>
          <div class="summary-stat stat-point">
            <div class="stat-label">포인트사용액</div>
            <div class="stat-value">{{ getCurrencyFormat(summaryTotals.totalPoint) }} 원</div>
          </div>
          <div class="summary-stat stat-memberdc">
            <div class="stat-label">멤버십할인액</div>
            <div class="stat-value">{{ getCurrencyFormat(summaryTotals.totalMemberDc) }} 원</div>
          </div>
        </div>

        <!-- ============ 리스트 테이블 ============ -->
        <div class="table-wrap">
          <table class="table table-bordered fs-6 data-table">
            <thead class="small">
              <tr class="text-center">
                <th style="width:40px;">삭제</th>
                <th>확인</th>
                <th>상태</th>
                <th>신청일</th>
                <th>출발일</th>
                <th>예약번호</th>
                <th>멤버십</th>
                <th>상품명</th>
                <th>신청자</th>
                <th>회원</th>
                <th>결제</th>
                <th>연락처</th>
                <th>확인자</th>
                <th>상품참조</th>
              </tr>
            </thead>
            <tbody class="small">
              <tr v-if="!isLoading && reqList.length === 0">
                <td colspan="14" class="empty-row">조건에 맞는 예약이 없습니다</td>
              </tr>
              <tr :key="i" v-for="(rList, i) in this.reqList" class="text-center"
                  :class="{ 'row-checked': checkedList.includes(rList.reqReserveCode) }">
                <td>
                  <input type="checkbox" class="form-check-input" :value="rList.reqReserveCode" v-model="checkedList" />
                </td>
                <td v-if="rList.rCopyFlag == 'N'"><span class="chip chip-danger">미확인</span></td>
                <td v-else><i class="bi bi-check-circle confirmed-icon"></i></td>

                <td v-if="rList.procCode != 'PY'">
                  <div v-if="rList.reqStatus === 'WP' && (rList.firstPayment != null && rList.firstPayment<100)">
                    <span v-if="rList.p1PayDate == undefined && rList.p2PayDate == undefined" class="chip chip-pending">1차대기</span>
                    <span v-else-if="rList.p1PayDate != undefined && rList.p2PayDate == undefined" class="chip chip-pending">2차대기</span>
                  </div>
                  <span v-else class="chip" :class="'chip-proc-' + rList.procCode">{{ rList.procName }}</span>
                </td>
                <td v-else-if="rList.procCode === 'PY'">
                  <span v-if="isFullPay(rList.cstPrice_new, rList.actualPayAmount)" class="chip chip-success">
                    전액결제
                  </span>                
                  <span v-else class="chip chip-danger">부분결제</span>
                </td>

                <td>{{ getDateFormat(rList.reqDate) }}</td>
                <td>{{ getDateFormat(rList.reqDptDate) }}</td>
                <td class="text-primary"><a class="res-code-link" @click="goToReqReserveDetail(rList.reqReserveCode, rList.reqPdtCode,rList.rCopyFlag,rList.newResFlag);" style="cursor:pointer;">{{ rList.reqReserveCode }}</a></td>

                <td v-if="rList.memShip === 'N'"><span class="chip chip-membership">멤버십</span></td>
                <td v-else></td>
                
                <td class="text-start" v-if="rList.reqPdtCode.substr(0,2) === 'MX'">{{ rList.mxName }}</td>
                <td class="text-start" v-else>{{ rList.mName  }}</td>

                <td>{{ rList.reqName }}</td>
                <td v-if="rList.resMFlag === 'N'"><span class="chip chip-outline-danger">비회원</span></td>
                <td v-else></td>
                <td v-if="rList.paidFlag === 'Y'"><span class="chip chip-success">결제</span></td>
                <td v-else><span class="chip chip-muted">미결제</span></td>
                <td>{{ rList.reqTelNo }}</td>
                <td>{{ rList.checkerName }}</td>
                <td>
                  <button type="button" class="btn btn-ref btn-sm" @click="refProduct(rList.reqPdtCode);">
                    <i class="bi bi-search small"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  // DB에서 가져온 데이타
  data() {
    return {
      isLoading: false,              // 로딩중 여부

      reqList: [],
      rProc: [],

      skillInput: null,
      result: null,
      arrSearchData: [],

      //fullPayFlag: ""             //완불여부 (fp: 완불)
      noDispCxl: false,             //취소예약비표시

      resYear: String(new Date().getFullYear()),    //기본조회연도(당해연도)

      checkedList: [],              // 삭제체크된 reqReserveCode 목록
      delCheck: "Y",                // 삭제체크 여부
    };
  },
  created() {
    this.user = this.$store.state.user
    //console.log("this.user:", this.user)

    this.getReqProcLevel();
    this.getRequestConsultList();

    //console.log("AccessInfo:",this.$store.state.user); 
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    //화면표시용 총 건수(단순표시, 로직에 영향없음)
    totalCount() {
      return this.reqList.length;
    },

    summaryTotals() {
      let totalRevenue = 0
      let totalPaid = 0
      let totalCoupon = 0
      let totalPoint = 0
      let totalMemberDc = 0

      this.reqList.forEach(item => {
        if(item.procCode !== 'CO') return

        totalRevenue  += (item.cstPrice_org || 0) * 1
        totalPaid     += (item.actualPayAmount || 0) * 1
        totalPoint    += ((item.pPt || 0) * 1) + ((item.pPt2 || 0) * 1)
        totalCoupon   += ((item.pCt || 0) * 1) + ((item.pCt2 || 0) * 1)
        totalMemberDc += (item.memDCAmt || 0) * 1
      })

      return { totalRevenue, totalPaid, totalCoupon, totalPoint, totalMemberDc }
    }
  },
  mounted() {
    //권한없는 로그인 차단
    if(this.user.handlerGrade >= 20 || this.user.handlerGrade == undefined) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }

    //document.getElementById("notice").style.display = "none";
    if(this.user.handlerId != undefined)
    {
      document.getElementById("admin").style.display = "block";
    }
    document.getElementById("user").style.display = "none";    
  },

  methods: {
    //10원 미만 오차는 전액결제로 간주 (할인/쿠폰 절사로 인한 미세차이 허용)
    isFullPay(price, paid) {
      const DIFF_TOLERANCE = 10;
      return Math.abs((price*1) - (paid*1)) < DIFF_TOLERANCE;
    },

    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },

    //로딩인디케이터
    showLoading() {
      this.$loading.start()
      setTimeout(() => {
        this.$loading.finish()
      }, 3000)
    },

    async getReqProcLevel() {
      let rProc = await this.$api("/api/reqProcLevel", {});
      if(rProc.length > 0) {
        this.rProc = rProc
      }
      //console.log("rProc:",this.rProc);
    },

    async getRequestConsultList(cFlag) {
      //로딩표시 시작
      this.isLoading = true;
      this.$loading.start();

      let reqList_tmp = await this.$api("/api/reqResConsultList2", {});
      //console.log("reqList:",reqList_tmp);

      let reqList = [];
      let currentYear = String(new Date().getFullYear())    //당해연도
      reqList = reqList_tmp.filter(e => {return e.reqDate.substr(0,4) === currentYear});

      let j = 0
      while(j < reqList.length)
      {
        // 불명확한 데이타 방지
        reqList[j].pP1  = (reqList[j].pP1 == null || reqList[j].pP1 == undefined || reqList[j].pP1 == '') ? 0 : reqList[j].pP1
        reqList[j].pP2  = (reqList[j].pP2 == null || reqList[j].pP2 == undefined || reqList[j].pP2 == '') ? 0 : reqList[j].pP2
        reqList[j].pPt  = (reqList[j].pPt == null || reqList[j].pPt == undefined || reqList[j].pPt == '') ? 0 : reqList[j].pPt
        reqList[j].pPt2 = (reqList[j].pPt2 == null || reqList[j].pPt2 == undefined || reqList[j].pPt2 == '') ? 0 : reqList[j].pPt2

        if(reqList[j].procCode === "PY")
        {
          if(this.isFullPay(reqList[j].cstPrice_new, (reqList[j].pP1*1) + (reqList[j].pP2*1) + (reqList[j].pPt*1)))
          {
            reqList[j].fullPayFlag = "Y"
          }
          else
          {
            reqList[j].fullPayFlag = "N"
          }
        }
        j++
      }

      // if(cFlag === "cx")
      // {
      //   reqList = reqList.filter(e => {
      //     return e.reqStat != "CX"
      //   })
      // }

      // getRequestConsultList의 cx 필터도 동일하게
      if(cFlag === "cx") {
        reqList = reqList.filter(e => { return e.procCode != "CX" })   // reqStat → procCode
      }

      let i=0;
      let arrSearchData = [];
      if(reqList.length > 0) {
        this.reqList = reqList;
        while(i<reqList.length) 
        {
          arrSearchData.push(reqList[i].reqReserveCode, reqList[i].reqName);
          i++;
        }
      }
      this.arrSearchData = arrSearchData;
      this.checkedList = [];                // 삭제체크 초기화

      this.isLoading = false;
      this.$loading.finish();               //인디케이터 완료
      //console.log("arrSearchData:",this.arrSearchData)
    },

    //자동완성기능
    submitAutoComplete() {
      const autocomplete = document.querySelector(".autocomplete");
      let result_tmp = [];
      if (this.dataInput) {
        autocomplete.classList.remove("disabled");
        autocomplete.style.display = "block"
        result_tmp = this.arrSearchData.filter((e) => {
          return String(e).match(new RegExp("^" + this.dataInput.toUpperCase(), "i"));
        });
        //결과값 중복제거
        this.result = Array.from(new Set(result_tmp));        
      }
      else {
        autocomplete.classList.add("disabled");
        autocomplete.style.display = "none";
        this.getRequestConsultList()
      }
    },
    
    searchData(res) {
      // console.log("reqList1:", this.reqList);
      // console.log("res:",res);
      let reqList_tmp = this.reqList;
      if(res.substr(0,2) === "RQ") {
        this.reqList =  reqList_tmp.filter(e => {return e.reqReserveCode === res});
      }
      else {
        this.reqList =  reqList_tmp.filter(e => {return e.reqName === res});
      }

      //console.log("reqList_searchData:",this.reqList);
    },
    refProduct(pdtCode) {
      this.$router.push({path: '/detail', query: {productId: pdtCode}});
    },

    goToReqReserveDetail(seqReq, pCode, cCode, nFlag) {
      let newResFlag = (nFlag === undefined || nFlag === null || nFlag == "") ? 'N' : nFlag;     //신규정보 여부

      if(newResFlag === "Y") 
      {
        this.$router.push({path: '/reserveInfoDetail', query: {seqReq: seqReq, pCode: pCode, cCode: cCode}});
      }
      else
      {
        this.$router.push({path: '/reserveInfoDetail_old', query: {seqReq: seqReq, pCode: pCode, cCode: cCode}});
      }

      //console.log("oId:", orderId);
    },

    async changeResYear() {

      this.isLoading = true;
      this.$loading.start();

      if(this.resYear === 'A') 
      {
        this.getRequestConsultList();
      }
      else if(this.resYear === '2026')    //신규정보
      {
        let reqList_tmp1 = await this.$api("/api/reqResConsultList2", {})
        this.reqList = reqList_tmp1.filter(e => {return e.reqDate.substr(0,4) >= "2026";});
      }
      else if(this.resYear === '2025')    //2025년도 예약
      {
        let reqList_tmp1 = await this.$api("/api/reqResConsultList2", {})
        this.reqList = reqList_tmp1.filter(e => {return e.reqDate.substr(0,4) >= "2025" && e.reqDate.substr(0,4) < "2026";});
      }
      else 
      {
        let reqList_tmp = await this.$api("/api/reqResConsultList2", {})
        //console.log("reqList_tmp:",reqList_tmp);
        this.reqList = reqList_tmp.filter(e => {return e.reqDate.substr(0,4) <= "2024";});
      }
      this.isLoading = false;
      this.$loading.finish();       //인디케이터 중지      
    },

    async changeProcCode() {
      if(this.rProcCode === 'A') 
      {
        this.getRequestConsultList();
      }
      else if(this.rProcCode === 'NC')    //신규정보
      {
        let reqList_tmp1 = await this.$api("/api/reqResConsultList2", {})
        //console.log("reqList_tmp1:",reqList_tmp1);
        this.reqList = reqList_tmp1.filter(e => {return e.rCopyFlag === 'N'});
        //console.log("reqList:", this.reqList)
      }
      else if(this.rProcCode === 'MEM')    //멤버십
      {
        let reqList_tmp1 = await this.$api("/api/reqResConsultList2", {})
        //console.log("reqList_tmp1:",reqList_tmp1);
        this.reqList = reqList_tmp1.filter(e => {return (e.memLevel === 'P' || e.memLevel === 'S')});
      }
      else if(this.rProcCode === 'FP')    //전액결제
      {
        let reqList_tmp1 = await this.$api("/api/reqResConsultList2", {})
        this.reqList = reqList_tmp1.filter(e => {return (e.reqStatus === 'PY' && this.isFullPay(e.cstPrice_new, (e.pP1*1 + e.pP2*1 + e.pPt*1)))});
      }
      else if(this.rProcCode === 'PP')    //부분결제
      {
        let reqList_tmp1 = await this.$api("/api/reqResConsultList2", {})
        this.reqList = reqList_tmp1.filter(e => {return (e.reqStatus === 'PY' && !this.isFullPay(e.cstPrice_new, (e.pP1*1 + e.pP2*1 + e.pPt*1)))});
      }
      else 
      {
        let reqList_tmp = await this.$api("/api/reqResConsultList2", {})
        //console.log("reqList_tmp:",reqList_tmp);
        this.reqList = reqList_tmp.filter(e => {return e.reqStatus === this.rProcCode});
      }
    },

    //취소된 예약비표시처리
    async cxlNoDisplay(dFlag){
      if(dFlag === true)
      {
        this.getRequestConsultList("cx")
        //let reqList_tmp = await this.$api("/api/reqResConsultList2", {})
      }
      else
      {
        this.getRequestConsultList();
      }
    },

    // 선택예약 삭제상태 변경
    async deleteChecked() {
      // this.delCheck = true;       // 삭제작업판단

      if (this.checkedList.length === 0) return;

      var swal = require('sweetalert2');
      const confirmResult = await swal.fire({
        title: '처리확인',
        text: `선택한 ${this.checkedList.length}건을 처리하시겠습니까?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '작업',
        cancelButtonText: '취소'
      });

      if (!confirmResult.isConfirmed) return;

      try {
        this.isLoading = true;
        this.$loading.start();

        await this.$api('/api/updRes_delFlag', { param: [this.delCheck, this.checkedList] });

        swal.fire({
          title: '처리완료',
          icon: 'success',
          timer: 1200,
          showConfirmButton: false
        });

        this.checkedList = [];
        await this.getRequestConsultList();   // 리스트 재조회
      } catch (err) {
        console.error('deleteChecked error:', err);
        swal.fire({
          title: '처리실패',
          text: '처리 중 오류가 발생했습니다.',
          icon: 'error'
        });
      } finally {
        this.isLoading = false;
        this.$loading.finish();
      }
    },

  }
}
</script>

<style scoped>
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css');

.admin-list-page {
  --ink: #0f1720;
  --muted: #3d4652;
  --paper: #f4f6f8;
  --card: #ffffff;
  --line: #d7dce2;
  --accent: #0a6169;
  --accent-soft: #dcf0ef;
  --warn: #a85f14;
  --warn-soft: #fbe8cf;
  --danger: #a52e27;
  --danger-soft: #f8dad8;
  --success: #1f6e44;
  --success-soft: #d9f0e4;
  --point: #5b46c9;
  --point-soft: #e8e4fb;
  --cobalt: #1e4fa3;
  --cobalt-soft: #dde7f7;  

  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Malgun Gothic', sans-serif;
  color: var(--ink);
  background: var(--paper);
  min-height: 100%;
  padding: 0.75rem;
}

/* ---------- 로딩 인디케이터 ---------- */
.saving-indicator {
  position: fixed;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  background: rgba(255,255,255,0.97);
  border-radius: 12px;
  padding: 1.75rem 2.25rem;
  box-shadow: 0 4px 24px rgba(20, 30, 40, 0.12);
  display: flex;
  align-items: center;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--accent);
}
.spinner {
  width: 26px;
  height: 26px;
  border: 4px solid #dfe6e7;
  border-top: 4px solid var(--accent);
  border-radius: 50%;
  margin-right: 1rem;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ---------- 필터 툴바 ---------- */
.toolbar-card {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 0.75rem 1rem 0.5rem;
  margin-bottom: 0.9rem;
  box-shadow: 0 1px 3px rgba(20,30,40,0.05);
}
.top-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.flex-item { margin: 4px; }

.field-select {
  border: 1px solid var(--line);
  border-radius: 8px;
  font-weight: 600;
  color: var(--ink);
}
.field-select:focus { border-color: var(--accent); box-shadow: 0 0 0 3px var(--accent-soft); }

.btn-del {
  background: var(--danger-soft);
  color: var(--danger);
  border: 1px solid transparent;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.4rem 0.8rem;
}
.btn-del:disabled { background: #eceef1; color: #a7aeb6; }
.btn-del:not(:disabled):hover { background: var(--danger); color: #fff; }

.toggle-item .form-check-label { font-size: 0.85rem; font-weight: 600; color: var(--muted); padding-top: 2px; }
.form-check-input:checked { background-color: var(--accent); border-color: var(--accent); }

.search-item { position: relative; }
.search-box { position: relative; display: flex; align-items: center; }
.search-icon { position: absolute; left: 10px; color: var(--muted); font-size: 0.85rem; pointer-events: none; }
.search-input {
  padding-left: 1.9rem;
  border: 1px solid var(--line);
  border-radius: 8px;
  min-width: 200px;
}
.search-input:focus { border-color: var(--accent); box-shadow: 0 0 0 3px var(--accent-soft); }

.autocomplete {
  position: absolute;
  top: 105%;
  left: 0;
  right: 0;
  z-index: 30;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(20,30,40,0.12);
  max-height: 220px;
  overflow-y: auto;
}
.autocomplete.disabled { display: none; }
.ac-item {
  padding: 0.45rem 0.8rem;
  font-size: 0.85rem;
  color: var(--success);
  cursor: pointer;
}
.ac-item:hover { background: var(--accent-soft); }

.count-bar {
  font-size: 0.8rem;
  color: var(--muted);
  padding: 0.3rem 0.3rem 0.1rem;
  text-align: left;
}
.count-bar b { color: var(--accent); font-size: 0.92rem; }

/* ---------- 재무 요약바 ---------- */
.summary-bar {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.75rem;
  margin-bottom: 0.9rem;
}
.summary-stat {
  background: var(--card);
  border: 1px solid var(--line);
  border-left: 4px solid var(--line);
  border-radius: 10px;
  padding: 0.65rem 0.9rem;
  box-shadow: 0 1px 3px rgba(20,30,40,0.05);
}
.stat-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--muted);
  margin-bottom: 0.15rem;
}
.stat-value {
  font-size: 1.15rem;
  font-weight: 800;
  color: var(--ink);
  text-align: right;
}
.stat-revenue { border-left-color: var(--accent); }
.stat-revenue .stat-value { color: var(--accent); }
.stat-paid { border-left-color: var(--success); }
.stat-paid .stat-value { color: var(--success); }
.stat-coupon { border-left-color: var(--warn); }
.stat-coupon .stat-value { color: var(--warn); }
.stat-point { border-left-color: var(--point); }
.stat-point .stat-value { color: var(--point); }
.stat-memberdc { border-left-color: var(--cobalt); }
.stat-memberdc .stat-value { color: var(--cobalt); }

@media (max-width: 900px) {
  .summary-bar { grid-template-columns: repeat(2, 1fr); }
}

/* ---------- 테이블 ---------- */
.table-wrap {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 12px;
  overflow: auto;
  max-height: 74vh;
  box-shadow: 0 1px 3px rgba(20,30,40,0.05);
}
.data-table { margin-bottom: 0; border: none; }
.data-table thead th {
  position: sticky;
  top: 0;
  z-index: 5;
  background: #eef1f3;
  color: var(--ink);
  font-weight: 700;
  border-color: var(--line) !important;
  box-shadow: 0 1px 0 var(--line);
}
.data-table tbody td {
  border-color: var(--line) !important;
  color: var(--ink);
  vertical-align: middle;
}
.data-table tbody tr:nth-child(even) { background: #fafbfc; }
.data-table tbody tr:hover { background: var(--accent-soft); }
.data-table tbody tr.row-checked { background: #fdeee0 !important; }

.empty-row {
  padding: 2rem 0;
  color: var(--muted);
  font-size: 0.95rem;
  font-weight: 600;
}

.res-code-link { font-weight: 700; color: var(--accent); text-decoration: none; }
.res-code-link:hover { text-decoration: underline; }

.confirmed-icon { color: var(--success); font-size: 0.95rem; }

.btn-ref {
  background: var(--card);
  border: 1px solid var(--success);
  color: var(--success);
  border-radius: 6px;
}
.btn-ref:hover { background: var(--success); color: #fff; }

/* ---------- 상태/결제 뱃지 ---------- */
.chip {
  display: inline-block;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  white-space: nowrap;
}
.chip-success { background: var(--success-soft); color: var(--success); }
.chip-danger { background: var(--danger-soft); color: var(--danger); }
.chip-pending, .chip-warn { background: var(--warn-soft); color: var(--warn); }
.chip-membership { background: var(--accent-soft); color: var(--accent); }
.chip-muted { background: #eceef1; color: var(--muted); }
.chip-outline-danger { background: #fff; color: var(--danger); border: 1px solid var(--danger); }

.chip-proc-CO { background: var(--success-soft); color: var(--success); }
.chip-proc-CX { background: var(--danger-soft); color: var(--danger); }
.chip-proc-RP, .chip-proc-WP { background: var(--warn-soft); color: var(--warn); }
.chip-proc-NC { background: var(--accent-soft); color: var(--accent); }

@media (max-width: 900px) {
  .top-container { justify-content: center; }
  .table-wrap { max-height: 60vh; }
}
</style>